import _slicedToArray from "/home/runner/work/postman-marketing-website-www/postman-marketing-website-www/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import wr, { useState as gt } from "react";
import v from "styled-components";
import e from "prop-types";
var We = {
    exports: {}
  },
  de = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var mr;
function ut() {
  if (mr) return de;
  mr = 1;
  var r = wr,
    i = Symbol.for("react.element"),
    a = Symbol.for("react.fragment"),
    o = Object.prototype.hasOwnProperty,
    d = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
    g = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    };
  function h(p, m, f) {
    var x,
      b = {},
      _ = null,
      w = null;
    f !== void 0 && (_ = "" + f), m.key !== void 0 && (_ = "" + m.key), m.ref !== void 0 && (w = m.ref);
    for (x in m) {
      o.call(m, x) && !g.hasOwnProperty(x) && (b[x] = m[x]);
    }
    if (p && p.defaultProps) for (x in m = p.defaultProps, m) {
      b[x] === void 0 && (b[x] = m[x]);
    }
    return {
      $$typeof: i,
      type: p,
      key: _,
      ref: w,
      props: b,
      _owner: d.current
    };
  }
  return de.Fragment = a, de.jsx = h, de.jsxs = h, de;
}
var ce = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var fr;
function pt() {
  return fr || (fr = 1, process.env.NODE_ENV !== "production" && function () {
    var r = wr,
      i = Symbol.for("react.element"),
      a = Symbol.for("react.portal"),
      o = Symbol.for("react.fragment"),
      d = Symbol.for("react.strict_mode"),
      g = Symbol.for("react.profiler"),
      h = Symbol.for("react.provider"),
      p = Symbol.for("react.context"),
      m = Symbol.for("react.forward_ref"),
      f = Symbol.for("react.suspense"),
      x = Symbol.for("react.suspense_list"),
      b = Symbol.for("react.memo"),
      _ = Symbol.for("react.lazy"),
      w = Symbol.for("react.offscreen"),
      L = Symbol.iterator,
      R = "@@iterator";
    function l(n) {
      if (n === null || typeof n != "object") return null;
      var s = L && n[L] || n[R];
      return typeof s == "function" ? s : null;
    }
    var $ = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function S(n) {
      {
        for (var s = arguments.length, c = new Array(s > 1 ? s - 1 : 0), y = 1; y < s; y++) {
          c[y - 1] = arguments[y];
        }
        W("error", n, c);
      }
    }
    function W(n, s, c) {
      {
        var y = $.ReactDebugCurrentFrame,
          N = y.getStackAddendum();
        N !== "" && (s += "%s", c = c.concat([N]));
        var k = c.map(function (C) {
          return String(C);
        });
        k.unshift("Warning: " + s), Function.prototype.apply.call(console[n], console, k);
      }
    }
    var oe = !1,
      ie = !1,
      le = !1,
      I = !1,
      O = !1,
      T;
    T = Symbol.for("react.module.reference");
    function Y(n) {
      return !!(typeof n == "string" || typeof n == "function" || n === o || n === g || O || n === d || n === f || n === x || I || n === w || oe || ie || le || typeof n == "object" && n !== null && (n.$$typeof === _ || n.$$typeof === b || n.$$typeof === h || n.$$typeof === p || n.$$typeof === m ||
      // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      n.$$typeof === T || n.getModuleId !== void 0));
    }
    function X(n, s, c) {
      var y = n.displayName;
      if (y) return y;
      var N = s.displayName || s.name || "";
      return N !== "" ? c + "(" + N + ")" : c;
    }
    function G(n) {
      return n.displayName || "Context";
    }
    function D(n) {
      if (n == null) return null;
      if (typeof n.tag == "number" && S("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof n == "function") return n.displayName || n.name || null;
      if (typeof n == "string") return n;
      switch (n) {
        case o:
          return "Fragment";
        case a:
          return "Portal";
        case g:
          return "Profiler";
        case d:
          return "StrictMode";
        case f:
          return "Suspense";
        case x:
          return "SuspenseList";
      }
      if (typeof n == "object") switch (n.$$typeof) {
        case p:
          var s = n;
          return G(s) + ".Consumer";
        case h:
          var c = n;
          return G(c._context) + ".Provider";
        case m:
          return X(n, n.render, "ForwardRef");
        case b:
          var y = n.displayName || null;
          return y !== null ? y : D(n.type) || "Memo";
        case _:
          {
            var N = n,
              k = N._payload,
              C = N._init;
            try {
              return D(C(k));
            } catch (_unused) {
              return null;
            }
          }
      }
      return null;
    }
    var Z = Object.assign,
      ae = 0,
      Ue,
      Ye,
      Xe,
      Ge,
      Je,
      Qe,
      Ke;
    function Ze() {}
    Ze.__reactDisabledLog = !0;
    function Hr() {
      {
        if (ae === 0) {
          Ue = console.log, Ye = console.info, Xe = console.warn, Ge = console.error, Je = console.group, Qe = console.groupCollapsed, Ke = console.groupEnd;
          var n = {
            configurable: !0,
            enumerable: !0,
            value: Ze,
            writable: !0
          };
          Object.defineProperties(console, {
            info: n,
            log: n,
            warn: n,
            error: n,
            group: n,
            groupCollapsed: n,
            groupEnd: n
          });
        }
        ae++;
      }
    }
    function Wr() {
      {
        if (ae--, ae === 0) {
          var n = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Z({}, n, {
              value: Ue
            }),
            info: Z({}, n, {
              value: Ye
            }),
            warn: Z({}, n, {
              value: Xe
            }),
            error: Z({}, n, {
              value: Ge
            }),
            group: Z({}, n, {
              value: Je
            }),
            groupCollapsed: Z({}, n, {
              value: Qe
            }),
            groupEnd: Z({}, n, {
              value: Ke
            })
          });
        }
        ae < 0 && S("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Re = $.ReactCurrentDispatcher,
      Fe;
    function me(n, s, c) {
      {
        if (Fe === void 0) try {
          throw Error();
        } catch (N) {
          var y = N.stack.trim().match(/\n( *(at )?)/);
          Fe = y && y[1] || "";
        }
        return "\n" + Fe + n;
      }
    }
    var Le = !1,
      fe;
    {
      var Mr = typeof WeakMap == "function" ? WeakMap : Map;
      fe = new Mr();
    }
    function er(n, s) {
      if (!n || Le) return "";
      {
        var c = fe.get(n);
        if (c !== void 0) return c;
      }
      var y;
      Le = !0;
      var N = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var k;
      k = Re.current, Re.current = null, Hr();
      try {
        if (s) {
          var C = function C() {
            throw Error();
          };
          if (Object.defineProperty(C.prototype, "props", {
            set: function set() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(C, []);
            } catch (M) {
              y = M;
            }
            Reflect.construct(n, [], C);
          } else {
            try {
              C.call();
            } catch (M) {
              y = M;
            }
            n.call(C.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (M) {
            y = M;
          }
          n();
        }
      } catch (M) {
        if (M && y && typeof M.stack == "string") {
          for (var j = M.stack.split("\n"), B = y.stack.split("\n"), E = j.length - 1, P = B.length - 1; E >= 1 && P >= 0 && j[E] !== B[P];) {
            P--;
          }
          for (; E >= 1 && P >= 0; E--, P--) {
            if (j[E] !== B[P]) {
              if (E !== 1 || P !== 1) do {
                if (E--, P--, P < 0 || j[E] !== B[P]) {
                  var A = "\n" + j[E].replace(" at new ", " at ");
                  return n.displayName && A.includes("<anonymous>") && (A = A.replace("<anonymous>", n.displayName)), typeof n == "function" && fe.set(n, A), A;
                }
              } while (E >= 1 && P >= 0);
              break;
            }
          }
        }
      } finally {
        Le = !1, Re.current = k, Wr(), Error.prepareStackTrace = N;
      }
      var te = n ? n.displayName || n.name : "",
        pr = te ? me(te) : "";
      return typeof n == "function" && fe.set(n, pr), pr;
    }
    function zr(n, s, c) {
      return er(n, !1);
    }
    function Vr(n) {
      var s = n.prototype;
      return !!(s && s.isReactComponent);
    }
    function he(n, s, c) {
      if (n == null) return "";
      if (typeof n == "function") return er(n, Vr(n));
      if (typeof n == "string") return me(n);
      switch (n) {
        case f:
          return me("Suspense");
        case x:
          return me("SuspenseList");
      }
      if (typeof n == "object") switch (n.$$typeof) {
        case m:
          return zr(n.render);
        case b:
          return he(n.type, s, c);
        case _:
          {
            var y = n,
              N = y._payload,
              k = y._init;
            try {
              return he(k(N), s, c);
            } catch (_unused2) {}
          }
      }
      return "";
    }
    var xe = Object.prototype.hasOwnProperty,
      rr = {},
      tr = $.ReactDebugCurrentFrame;
    function ye(n) {
      if (n) {
        var s = n._owner,
          c = he(n.type, n._source, s ? s.type : null);
        tr.setExtraStackFrame(c);
      } else tr.setExtraStackFrame(null);
    }
    function qr(n, s, c, y, N) {
      {
        var k = Function.call.bind(xe);
        for (var C in n) {
          if (k(n, C)) {
            var j = void 0;
            try {
              if (typeof n[C] != "function") {
                var B = Error((y || "React class") + ": " + c + " type `" + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof n[C] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw B.name = "Invariant Violation", B;
              }
              j = n[C](s, C, y, c, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (E) {
              j = E;
            }
            j && !(j instanceof Error) && (ye(N), S("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", c, C, typeof j), ye(null)), j instanceof Error && !(j.message in rr) && (rr[j.message] = !0, ye(N), S("Failed %s type: %s", c, j.message), ye(null));
          }
        }
      }
    }
    var Ur = Array.isArray;
    function Ee(n) {
      return Ur(n);
    }
    function Yr(n) {
      {
        var s = typeof Symbol == "function" && Symbol.toStringTag,
          c = s && n[Symbol.toStringTag] || n.constructor.name || "Object";
        return c;
      }
    }
    function Xr(n) {
      try {
        return nr(n), !1;
      } catch (_unused3) {
        return !0;
      }
    }
    function nr(n) {
      return "" + n;
    }
    function or(n) {
      if (Xr(n)) return S("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Yr(n)), nr(n);
    }
    var se = $.ReactCurrentOwner,
      Gr = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      },
      ir,
      lr,
      Pe;
    Pe = {};
    function Jr(n) {
      if (xe.call(n, "ref")) {
        var s = Object.getOwnPropertyDescriptor(n, "ref").get;
        if (s && s.isReactWarning) return !1;
      }
      return n.ref !== void 0;
    }
    function Qr(n) {
      if (xe.call(n, "key")) {
        var s = Object.getOwnPropertyDescriptor(n, "key").get;
        if (s && s.isReactWarning) return !1;
      }
      return n.key !== void 0;
    }
    function Kr(n, s) {
      if (typeof n.ref == "string" && se.current && s && se.current.stateNode !== s) {
        var c = D(se.current.type);
        Pe[c] || (S('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', D(se.current.type), n.ref), Pe[c] = !0);
      }
    }
    function Zr(n, s) {
      {
        var c = function c() {
          ir || (ir = !0, S("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        c.isReactWarning = !0, Object.defineProperty(n, "key", {
          get: c,
          configurable: !0
        });
      }
    }
    function et(n, s) {
      {
        var c = function c() {
          lr || (lr = !0, S("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        c.isReactWarning = !0, Object.defineProperty(n, "ref", {
          get: c,
          configurable: !0
        });
      }
    }
    var rt = function rt(n, s, c, y, N, k, C) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: i,
        // Built-in properties that belong on the element
        type: n,
        key: s,
        ref: c,
        props: C,
        // Record the component responsible for creating this element.
        _owner: k
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: N
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function tt(n, s, c, y, N) {
      {
        var k,
          C = {},
          j = null,
          B = null;
        c !== void 0 && (or(c), j = "" + c), Qr(s) && (or(s.key), j = "" + s.key), Jr(s) && (B = s.ref, Kr(s, N));
        for (k in s) {
          xe.call(s, k) && !Gr.hasOwnProperty(k) && (C[k] = s[k]);
        }
        if (n && n.defaultProps) {
          var E = n.defaultProps;
          for (k in E) {
            C[k] === void 0 && (C[k] = E[k]);
          }
        }
        if (j || B) {
          var P = typeof n == "function" ? n.displayName || n.name || "Unknown" : n;
          j && Zr(C, P), B && et(C, P);
        }
        return rt(n, j, B, N, y, se.current, C);
      }
    }
    var Be = $.ReactCurrentOwner,
      ar = $.ReactDebugCurrentFrame;
    function re(n) {
      if (n) {
        var s = n._owner,
          c = he(n.type, n._source, s ? s.type : null);
        ar.setExtraStackFrame(c);
      } else ar.setExtraStackFrame(null);
    }
    var Ie;
    Ie = !1;
    function Oe(n) {
      return typeof n == "object" && n !== null && n.$$typeof === i;
    }
    function sr() {
      {
        if (Be.current) {
          var n = D(Be.current.type);
          if (n) return "\n\nCheck the render method of `" + n + "`.";
        }
        return "";
      }
    }
    function nt(n) {
      return "";
    }
    var dr = {};
    function ot(n) {
      {
        var s = sr();
        if (!s) {
          var c = typeof n == "string" ? n : n.displayName || n.name;
          c && (s = "\n\nCheck the top-level render call using <" + c + ">.");
        }
        return s;
      }
    }
    function cr(n, s) {
      {
        if (!n._store || n._store.validated || n.key != null) return;
        n._store.validated = !0;
        var c = ot(s);
        if (dr[c]) return;
        dr[c] = !0;
        var y = "";
        n && n._owner && n._owner !== Be.current && (y = " It was passed a child from " + D(n._owner.type) + "."), re(n), S('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', c, y), re(null);
      }
    }
    function gr(n, s) {
      {
        if (typeof n != "object") return;
        if (Ee(n)) for (var c = 0; c < n.length; c++) {
          var y = n[c];
          Oe(y) && cr(y, s);
        } else if (Oe(n)) n._store && (n._store.validated = !0);else if (n) {
          var N = l(n);
          if (typeof N == "function" && N !== n.entries) for (var k = N.call(n), C; !(C = k.next()).done;) {
            Oe(C.value) && cr(C.value, s);
          }
        }
      }
    }
    function it(n) {
      {
        var s = n.type;
        if (s == null || typeof s == "string") return;
        var c;
        if (typeof s == "function") c = s.propTypes;else if (typeof s == "object" && (s.$$typeof === m ||
        // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        s.$$typeof === b)) c = s.propTypes;else return;
        if (c) {
          var y = D(s);
          qr(c, n.props, "prop", y, n);
        } else if (s.PropTypes !== void 0 && !Ie) {
          Ie = !0;
          var N = D(s);
          S("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", N || "Unknown");
        }
        typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && S("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function lt(n) {
      {
        for (var s = Object.keys(n.props), c = 0; c < s.length; c++) {
          var y = s[c];
          if (y !== "children" && y !== "key") {
            re(n), S("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), re(null);
            break;
          }
        }
        n.ref !== null && (re(n), S("Invalid attribute `ref` supplied to `React.Fragment`."), re(null));
      }
    }
    function ur(n, s, c, y, N, k) {
      {
        var C = Y(n);
        if (!C) {
          var j = "";
          (n === void 0 || typeof n == "object" && n !== null && Object.keys(n).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var B = nt();
          B ? j += B : j += sr();
          var E;
          n === null ? E = "null" : Ee(n) ? E = "array" : n !== void 0 && n.$$typeof === i ? (E = "<" + (D(n.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : E = typeof n, S("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", E, j);
        }
        var P = tt(n, s, c, N, k);
        if (P == null) return P;
        if (C) {
          var A = s.children;
          if (A !== void 0) if (y) {
            if (Ee(A)) {
              for (var te = 0; te < A.length; te++) {
                gr(A[te], n);
              }
              Object.freeze && Object.freeze(A);
            } else S("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
          } else gr(A, n);
        }
        return n === o ? lt(P) : it(P), P;
      }
    }
    function at(n, s, c) {
      return ur(n, s, c, !0);
    }
    function st(n, s, c) {
      return ur(n, s, c, !1);
    }
    var dt = st,
      ct = at;
    ce.Fragment = o, ce.jsx = dt, ce.jsxs = ct;
  }()), ce;
}
process.env.NODE_ENV === "production" ? We.exports = ut() : We.exports = pt();
var t = We.exports,
  Me = {
    exports: {}
  },
  hr = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if (hr) {
  var xr = new Uint8Array(16);
  Me.exports = function () {
    return hr(xr), xr;
  };
} else {
  var yr = new Array(16);
  Me.exports = function () {
    for (var i = 0, a; i < 16; i++) {
      i & 3 || (a = Math.random() * 4294967296), yr[i] = a >>> ((i & 3) << 3) & 255;
    }
    return yr;
  };
}
var Tr = Me.exports,
  Nr = [];
for (var be = 0; be < 256; ++be) {
  Nr[be] = (be + 256).toString(16).substr(1);
}
function mt(r, i) {
  var a = i || 0,
    o = Nr;
  return [o[r[a++]], o[r[a++]], o[r[a++]], o[r[a++]], "-", o[r[a++]], o[r[a++]], "-", o[r[a++]], o[r[a++]], "-", o[r[a++]], o[r[a++]], "-", o[r[a++]], o[r[a++]], o[r[a++]], o[r[a++]], o[r[a++]], o[r[a++]]].join("");
}
var Sr = mt,
  ft = Tr,
  ht = Sr,
  br,
  $e,
  Ae = 0,
  De = 0;
function xt(r, i, a) {
  var o = i && a || 0,
    d = i || [];
  r = r || {};
  var g = r.node || br,
    h = r.clockseq !== void 0 ? r.clockseq : $e;
  if (g == null || h == null) {
    var p = ft();
    g == null && (g = br = [p[0] | 1, p[1], p[2], p[3], p[4], p[5]]), h == null && (h = $e = (p[6] << 8 | p[7]) & 16383);
  }
  var m = r.msecs !== void 0 ? r.msecs : /* @__PURE__ */new Date().getTime(),
    f = r.nsecs !== void 0 ? r.nsecs : De + 1,
    x = m - Ae + (f - De) / 1e4;
  if (x < 0 && r.clockseq === void 0 && (h = h + 1 & 16383), (x < 0 || m > Ae) && r.nsecs === void 0 && (f = 0), f >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  Ae = m, De = f, $e = h, m += 122192928e5;
  var b = ((m & 268435455) * 1e4 + f) % 4294967296;
  d[o++] = b >>> 24 & 255, d[o++] = b >>> 16 & 255, d[o++] = b >>> 8 & 255, d[o++] = b & 255;
  var _ = m / 4294967296 * 1e4 & 268435455;
  d[o++] = _ >>> 8 & 255, d[o++] = _ & 255, d[o++] = _ >>> 24 & 15 | 16, d[o++] = _ >>> 16 & 255, d[o++] = h >>> 8 | 128, d[o++] = h & 255;
  for (var w = 0; w < 6; ++w) {
    d[o + w] = g[w];
  }
  return i || ht(d);
}
var yt = xt,
  bt = Tr,
  vt = Sr;
function _t(r, i, a) {
  var o = i && a || 0;
  typeof r == "string" && (i = r === "binary" ? new Array(16) : null, r = null), r = r || {};
  var d = r.random || (r.rng || bt)();
  if (d[6] = d[6] & 15 | 64, d[8] = d[8] & 63 | 128, i) for (var g = 0; g < 16; ++g) {
    i[o + g] = d[g];
  }
  return i || vt(d);
}
var jt = _t,
  Ct = yt,
  kr = jt,
  ze = kr;
ze.v1 = Ct;
ze.v4 = kr;
var F = ze;
var u = {
  colors: {
    // ************************************ STOP USING THESE
    // Main Colors
    deep_space_blue: "#1C272B",
    // Oranges
    light_orange: "#F4815B",
    orange_40_50: "rgba(249, 157, 120, 0.5)",
    orange_40_25: "rgba(249, 157, 120, 0.25)",
    // Blues
    night_sky: "#2B3B41",
    blue_steel: "#6D7F91",
    light_blue: "#DBE9F2",
    lighter_blue: "#F5F8FB",
    // Purples
    dark_purple: "#493E5E",
    light_purple: "#665C80",
    bright_purple: "#7D728E",
    // Grays
    grey_5: "#979797",
    grey_4: "#E1E1E1",
    white: "#FFFFFF",
    black: "000000",
    // ************************************ END: STOP USING THESE
    // ************************************ USE THESE INSTEAD
    // ORANGE
    orange_90: "#553326",
    orange_80: "#A12700",
    orange_70: "#D23F0E",
    orange_65: "#E0531F",
    orange_60: "#E05320",
    orange_55: "#FF6C37",
    orange_50: "#FF6C37",
    orange_40: "#FF8E64",
    orange_30: "#FFB091",
    orange_20: "#FFD1BE",
    orange_10: "#FFF1EB",
    // GREY
    grey_90: "#212121",
    grey_85: "#262626",
    grey_80: "#2B2B2B",
    grey_70: "#303030",
    grey_60: "#3B3B3B",
    grey_50: "#707070",
    grey_45: "#636363",
    grey_40: "#A6A6A6",
    grey_30: "#E6E6E6",
    grey_20: "#EDEDED",
    grey_10: "#F2F2F2",
    grey_05: "#F9F9F9",
    grey_00: "#FFFFFF",
    // BLUE
    blue_90: "#002D70",
    blue_80: "#00439D",
    blue_70: "#0053B8",
    blue_60: "#0265D2",
    blue_50: "#097BED",
    blue_40: "#3E92F2",
    blue_30: "#74AEF6",
    blue_20: "#ADCDFB",
    blue_10: "#E7F0FF",
    // YELLOW
    yellow_80: "#523A03",
    yellow_90: "#886000",
    yellow_70: "#AD7A03",
    yellow_60: "#DE9C00",
    yellow_50: "#FFB400",
    yellow_40: "#FFCF3F",
    yellow_30: "#FFE47E",
    yellow_20: "#FFF4BE",
    yellow_10: "#FFF9E0",
    // RED
    red_error: "#b70700",
    // BACKGROUNDS
    blue_95: "#01213C",
    yellow_05: "#FFFEF9",
    purple_05: "#EEE3FF",
    blue_enterprise: "#0B162A",
    lavender: "#E6EAFD",
    // Alias Colors
    content_color_primary: "".concat(function (r) {
      return r.theme.colors.grey_90;
    }, ";"),
    content_color_secondary: "".concat(function (r) {
      return r.theme.colors.grey_70;
    }),
    content_color_tertiary: "".concat(function (r) {
      return r.theme.colors.grey_50;
    })
  },
  shadows: {
    // mostly used on Cards
    card_shadow: "0 8px 16px -4px rgba(0, 0, 0, 0.08)",
    card_shadow_2: "0 8px 16px -4px rgba(0, 0, 0, 0.08)",
    form_shadow: "0px 5px 8px rgba(28, 39, 43, 0.05)",
    form_field_focus: "0 0 0 0.2rem rgba(0, 123, 255, .25)",
    screenshot_shadow: "0px 0px 10px 5px rgba(0,0,0,0.05)"
  },
  transitions: {
    all: "all 0.2s ease-in-out"
  },
  borderRadius: {
    small: "5px",
    medium: "10px",
    large: "15px"
  },
  mediaLayout: {
    small: "col-lg-6 offset-lg-3",
    medium: "col-md-8 offset-md-2",
    large: "col-lg-10 offset-lg-1"
  }
};
e.node;
var vr = v.hr.withConfig({
  displayName: "hrStyles__HRStyles",
  componentId: "sc-1pq34xj-0"
})(["border:0;border-top:1px solid ", ";margin-top:0;margin-bottom:0;"], u.colors.grey_30);
function q(_ref) {
  var r = _ref.fullWidth;
  return r ? /* @__PURE__ */t.jsx(vr, {}) : /* @__PURE__ */t.jsx("div", {
    className: "container",
    children: /* @__PURE__ */t.jsx(vr, {})
  });
}
q.propTypes = {
  fullWidth: e.bool
};
q.defaultProps = {
  fullWidth: !1
};
var U = v.section.withConfig({
    displayName: "SectionStyles",
    componentId: "sc-1r5eb44-0"
  })(["padding-top:", ";padding-bottom:", ";background-color:", ";@media (min-width:769px){padding-top:", ";padding-bottom:", ";}"], function (r) {
    return r.paddingTop || "30px";
  }, function (r) {
    return r.paddingBottom || "30px";
  }, function (r) {
    return r.backgroundColor ? u.colors[r.backgroundColor] : "#FFFFFF";
  }, function (r) {
    return r.paddingTop || "60px";
  }, function (r) {
    return r.paddingBottom || "60px";
  }),
  H = v.a.withConfig({
    displayName: "BaseLinkStyles",
    componentId: "sc-7vt82q-0"
  })(["color:", ";text-decoration:none;border-bottom:1px solid transparent;&:hover{text-decoration:none;border-bottom:1px solid ", ";cursor:pointer;transition:", ";}"], u.colors.blue_60, u.colors.blue_60, u.transitions.all),
  wt = v(H).withConfig({
    displayName: "BaseLinkStyles__ArrowLinkStyles",
    componentId: "sc-7vt82q-1"
  })(["&:hover,:active{border-bottom:1px solid ", ";color:", ";text-decoration:none;transition:", ";}"], function (r) {
    return r.className ? u.colors[r.className] : u.colors.blue_60;
  }, u.colors.blue_60, u.transitions.all),
  ve = v(H).withConfig({
    displayName: "BaseLinkStyles__FooterLinkStyles",
    componentId: "sc-7vt82q-2"
  })(["color:", ";display:block;line-height:1.7;border-bottom:none;&:hover,:active{border-bottom:none !important;line-height:1.7;display:block;}"], u.colors.grey_50),
  ee = function ee(r) {
    return r.replace(/\s+/g, "-").replace(/\?/g, "").toLowerCase();
  },
  Tt = function Tt(r) {
    var i = r.href;
    var a = i && !!i.match(document.location.host);
    return a && (i = i.split(document.location.host), i.shift(), i = i.join("/")), {
      url: i,
      isLocal: a
    };
  },
  Nt = function Nt(r) {
    var i = r,
      a;
    for (var o = 0; o < 10; o + 1) {
      a = i.tagName.toLowerCase(), a === "a" ? o = 10 : i = i.parentNode;
    }
    return i;
  },
  J = function J(r, i) {
    return r && i && window.pm && window.pm.ga("send", "event", r, "Click", i);
  };
function z(r) {
  return r === "new-tab-postman" || r === "external-postman" ? "noopener" : r === "new-tab-external-company" || r === "external-other" ? "noopener noreferrer" : r === "new-tab-external-nofollow" || r === "external-nofollow" ? "noopener noreferrer nofollow" : null;
}
function V(r) {
  var i = ["new-tab-postman", "new-tab-postman", "new-tab-external-company", "external-other", "new-tab-external-nofollow", "new-tab-external-nofollow"];
  for (var a = 0; a < i.length; a += 1) {
    if (i[a] === r) return "_blank";
    if (r === "same-tab") return "_self";
  }
  return "_self";
}
var _e = v.ul.withConfig({
    displayName: "Footer__Column",
    componentId: "sc-ruk9t6-0"
  })(["padding-left:0;margin-left:0;"]),
  je = v.li.withConfig({
    displayName: "Footer__ColumnRow",
    componentId: "sc-ruk9t6-1"
  })(["list-style-type:none;margin-bottom:0;padding:5px 0;"]),
  St = v.img.withConfig({
    displayName: "Footer__FooterImg",
    componentId: "sc-ruk9t6-2"
  })(["@media (min-width:768px){filter:grayscale(100%);transition:", ";&:hover{filter:grayscale(0);transition:", ";}}"], u.transitions.all, u.transitions.all),
  _r = v.span.withConfig({
    displayName: "Footer__Copyright",
    componentId: "sc-ruk9t6-3"
  })(["color:", ";font-size:1.2rem;"], u.colors.grey_50),
  kt = v.div.withConfig({
    displayName: "Footer__SocialSVG",
    componentId: "sc-ruk9t6-4"
  })(["display:inline-block;margin-right:8px;width:16px;height:16px;& svg{max-height:100%;width:auto;}&:hover{border-bottom:unset;}"]),
  Ce = v.h2.withConfig({
    displayName: "Footer__FooterColTitle",
    componentId: "sc-ruk9t6-5"
  })(['font-size:1.6rem !important;line-height:1.4;margin-bottom:8px;font-family:"Inter";font-weight:600;color:', ";"], u.colors.grey_50);
function Rr(_ref2) {
  var r = _ref2.data;
  var i = r.items.splice(0, 4);
  return /* @__PURE__ */t.jsxs(t.Fragment, {
    children: [/* @__PURE__ */t.jsx(q, {
      fullWidth: !0
    }), /* @__PURE__ */t.jsx("footer", {
      children: /* @__PURE__ */t.jsx(U, {
        id: "Footer",
        children: /* @__PURE__ */t.jsx("div", {
          className: "container small",
          children: /* @__PURE__ */t.jsx("div", {
            className: "row",
            children: /* @__PURE__ */t.jsx("div", {
              className: "col-sm-8 offset-sm-2 col-md-12 offset-md-0",
              children: /* @__PURE__ */t.jsxs("div", {
                className: "row",
                children: [/* @__PURE__ */t.jsxs("div", {
                  className: "col-6 col-md-3 col-lg-2 order-12 order-md-0 pad-md-right mt-auto mb-4",
                  children: [/* @__PURE__ */t.jsx(St, {
                    className: "img-fluid col-12 col-sm-9 col-md-12 mb-5 d-block",
                    src: r.src,
                    alt: r.alt
                  }), /* @__PURE__ */t.jsx(_r, {
                    className: "col-12 d-none d-md-block",
                    children: r.copyright
                  })]
                }), /* @__PURE__ */t.jsx("div", {
                  className: "col-6 col-md-3 offset-md-1 col-lg-3 offset-lg-2 order-1 order-md-2 mb-5 mb-md-0",
                  children: i.slice(0, 1).map(function (a) {
                    return /* @__PURE__ */t.jsxs("nav", {
                      "aria-labelledby": a.arialabelledby,
                      children: [/* @__PURE__ */t.jsx(Ce, {
                        id: a.arialabelledby,
                        children: a.title
                      }), /* @__PURE__ */t.jsx(_e, {
                        children: a.items && a.items.map(function (o) {
                          return /* @__PURE__ */t.jsx(je, {
                            children: /* @__PURE__ */t.jsx(ve, {
                              href: o.url,
                              rel: z(o.target),
                              target: V(o.target),
                              "aria-label": o.ariaLabel,
                              onClick: function onClick() {
                                J(o.category, o.label);
                              },
                              children: o.title
                            })
                          }, F.v4());
                        }) || ""
                      })]
                    }, F.v4());
                  })
                }), /* @__PURE__ */t.jsxs("div", {
                  className: "col-6 col-md-3 order-2 order-md-3",
                  children: [i.slice(1, 2).map(function (a) {
                    return /* @__PURE__ */t.jsx("div", {
                      children: /* @__PURE__ */t.jsxs("nav", {
                        "aria-labelledby": a.arialabelledby,
                        className: "mb-5",
                        children: [/* @__PURE__ */t.jsx(Ce, {
                          id: a.arialabelledby,
                          children: a.title
                        }), /* @__PURE__ */t.jsx(_e, {
                          children: a.items && a.items.map(function (o) {
                            return /* @__PURE__ */t.jsx(je, {
                              children: /* @__PURE__ */t.jsx(ve, {
                                href: o.url,
                                rel: z(o.target),
                                target: V(o.target),
                                "aria-label": o.ariaLabel,
                                onClick: function onClick() {
                                  J(o.category, o.label);
                                },
                                children: o.title
                              })
                            }, F.v4());
                          }) || ""
                        })]
                      })
                    }, F.v4());
                  }), i.slice(2, 3).map(function (a) {
                    return /* @__PURE__ */t.jsx("div", {
                      children: /* @__PURE__ */t.jsxs("nav", {
                        "aria-labelledby": a.arialabelledby,
                        className: "mb-5",
                        children: [/* @__PURE__ */t.jsx(Ce, {
                          id: a.arialabelledby,
                          children: a.title
                        }), /* @__PURE__ */t.jsx(_e, {
                          children: a.items && a.items.map(function (o) {
                            return /* @__PURE__ */t.jsx(je, {
                              children: /* @__PURE__ */t.jsx(ve, {
                                href: o.url,
                                rel: z(o.target),
                                target: V(o.target),
                                "aria-label": o.ariaLabel,
                                onClick: function onClick() {
                                  J(o.category, o.label);
                                },
                                children: o.title
                              })
                            }, F.v4());
                          }) || ""
                        })]
                      })
                    }, F.v4());
                  })]
                }), /* @__PURE__ */t.jsx("div", {
                  className: "col-6 col-md-2 col-lg-2 order-3 order-md-4",
                  children: /* @__PURE__ */t.jsx("div", {
                    className: "row",
                    children: i.slice(3, 4).map(function (a) {
                      return /* @__PURE__ */t.jsx("div", {
                        className: "col-sm-12",
                        children: /* @__PURE__ */t.jsxs("nav", {
                          "aria-labelledby": a.arialabelledby,
                          className: "mb-5",
                          children: [/* @__PURE__ */t.jsx(Ce, {
                            id: a.arialabelledby,
                            children: a.title
                          }), /* @__PURE__ */t.jsx(_e, {
                            children: a.items && a.items.map(function (o) {
                              return /* @__PURE__ */t.jsx(je, {
                                children: /* @__PURE__ */t.jsx("div", {
                                  className: "d-inline-block",
                                  children: /* @__PURE__ */t.jsx(ve, {
                                    href: o.url,
                                    rel: z(o.target),
                                    target: V(o.target),
                                    "aria-label": o.ariaLabel,
                                    onClick: function onClick() {
                                      J(o.category, o.label);
                                    },
                                    children: /* @__PURE__ */t.jsxs("div", {
                                      children: [/* @__PURE__ */t.jsx(kt, {
                                        className: "d-inline-block align-self-center",
                                        dangerouslySetInnerHTML: {
                                          __html: o.svg
                                        }
                                      }), o.title]
                                    })
                                  })
                                })
                              }, F.v4());
                            }) || ""
                          })]
                        })
                      }, F.v4());
                    })
                  })
                }), /* @__PURE__ */t.jsx("div", {
                  className: "col-12 d-block d-md-none text-center order-last",
                  children: /* @__PURE__ */t.jsx(_r, {
                    className: "col-12",
                    children: r.copyright
                  })
                })]
              })
            })
          })
        })
      })
    })]
  });
}
Rr.propTypes = {
  data: e.shape({
    type: e.string,
    src: e.string,
    alt: e.string,
    copyright: e.string,
    items: e.arrayOf(e.shape({}))
  })
};
Rr.defaultProps = {
  data: null
};
function Q(_ref3) {
  var r = _ref3.linkType,
    i = _ref3.src,
    a = _ref3.className,
    o = _ref3.target,
    d = _ref3.gaCategory,
    g = _ref3.gaLabel,
    h = _ref3.id,
    p = _ref3.as,
    _ref3$ariaLabel = _ref3.ariaLabel,
    m = _ref3$ariaLabel === void 0 ? null : _ref3$ariaLabel,
    f = _ref3.onClick,
    x = _ref3.event,
    b = _ref3.eventProp,
    _ = _ref3.children;
  var w = function w(L) {
    var R = Tt(Nt(L.target));
    return R.isLocal ? (document.location = R.url, !1) : (d && g && J(d, g), f && f(), -1);
  };
  return r === "arrowLink" || r === "reversedArrowLink" ? /* @__PURE__ */t.jsx(wt, {
    href: i,
    className: a || null,
    id: h,
    onClick: w,
    rel: z(o),
    target: V(o),
    as: p || "a",
    "aria-label": m,
    "data-event": x,
    "data-event-prop": b,
    children: r === "arrowLink" ? "".concat(_, " \u2192") : "\u2190 ".concat(_)
  }) : /* @__PURE__ */t.jsx(H, {
    href: i,
    className: a || null,
    id: h,
    onClick: w,
    rel: z(o),
    target: V(o),
    as: p || "a",
    "aria-label": m,
    "data-event": x,
    "data-event-prop": b,
    children: _
  });
}
Q.propTypes = {
  linkType: e.string,
  src: e.string,
  target: e.string,
  children: e.node.isRequired,
  className: e.string,
  id: e.string,
  gaCategory: e.string,
  gaLabel: e.string,
  as: e.string,
  ariaLabel: e.string,
  event: e.string,
  eventProp: e.string,
  onClick: e.oneOfType([e.func, e.bool])
};
Q.defaultProps = {
  linkType: "inlineLink",
  src: null,
  target: "",
  className: "",
  id: null,
  gaCategory: null,
  gaLabel: null,
  as: "a",
  ariaLabel: null,
  event: null,
  eventProp: null,
  onClick: !1
};
var Rt = v.section.withConfig({
  displayName: "Table__TableWrapper",
  componentId: "sc-7gt7w3-0"
})(["padding:", ";"], function (r) {
  return r.padding;
});
function Fr(_ref4) {
  var r = _ref4.padding,
    i = _ref4.headers,
    a = _ref4.items;
  return /* @__PURE__ */t.jsx(Rt, {
    padding: r,
    children: /* @__PURE__ */t.jsx("div", {
      className: "container",
      children: /* @__PURE__ */t.jsx("div", {
        className: "row",
        children: /* @__PURE__ */t.jsx("div", {
          className: "col-12",
          children: /* @__PURE__ */t.jsx("div", {
            className: "table-responsive table table-striped mb-2",
            children: /* @__PURE__ */t.jsxs("table", {
              className: "table",
              children: [/* @__PURE__ */t.jsx("thead", {
                children: /* @__PURE__ */t.jsx("tr", {
                  children: i.map(function (o) {
                    return /* @__PURE__ */t.jsx("th", {
                      scope: "col",
                      children: o
                    }, F.v4());
                  })
                })
              }), /* @__PURE__ */t.jsx("tbody", {
                children: a.map(function (o) {
                  return /* @__PURE__ */t.jsx("tr", {
                    children: Object.keys(o).map(function (d) {
                      return d === "url" ? /* @__PURE__ */t.jsx("td", {
                        children: /* @__PURE__ */t.jsx("a", {
                          href: o.url,
                          target: "_blank",
                          rel: "noopener noreferrer nofollow",
                          children: o.url
                        })
                      }, F.v4()) : d === "link" ? /* @__PURE__ */t.jsx("td", {
                        children: /* @__PURE__ */t.jsx("a", {
                          href: o.link.url,
                          target: "_blank",
                          rel: "noopener noreferrer",
                          children: o.link.title
                        })
                      }, F.v4()) : /* @__PURE__ */t.jsx("td", {
                        children: o[d]
                      }, F.v4());
                    })
                  }, F.v4());
                })
              })]
            })
          })
        })
      })
    })
  });
}
Fr.propTypes = {
  padding: e.string,
  headers: e.arrayOf(e.string).isRequired,
  items: e.arrayOf(e.shape({})).isRequired
};
Fr.defaultProps = {
  padding: "30px 60px"
};
var ge = v.ol.withConfig({
    displayName: "ListsStyles__OrderedListStyles",
    componentId: "sc-v367c5-0"
  })(["margin-bottom:2.4rem;margin-left:0px;padding-left:3.2rem;li{color:", ";line-height:1.5;margin-bottom:1.2rem;position:relative;display:list-item;padding-left:1rem;margin-left:1rem;margin-bottom:2.4rem;&:before,&:after{display:inline-block;text-align:right;}&:before{direction:rtl;margin-left:-2.8rem;padding-right:1.6rem;width:2.8rem;}ol,ul{margin-top:2.4rem;padding-left:0px;}ul{margin-top:2.4rem;padding-left:0px;& li{padding-left:3.3rem;margin-left:0px;}}}li::marker{color:", " !important;}li > ol{list-style:lower-alpha;}"], u.colors.grey_90, u.colors.grey_70),
  ne = v.ul.withConfig({
    displayName: "ListsStyles__UnorderedListStyles",
    componentId: "sc-v367c5-1"
  })(["margin-bottom:2.4rem;margin-left:0px;padding-left:2rem;list-style-type:none;li{padding-left:3.3rem;color:", ';line-height:1.5;margin-bottom:2.4rem;position:relative;display:list-item;list-style-type:none;background-image:url(https://voyager.postman.com/icon/starburst-four-point.svg);background-position:0 0.8rem;background-size:1rem 1rem;background-repeat:no-repeat;ul,ol{margin-top:2.4rem;}ul{padding-left:0px;}ol{padding-left:0.9rem;li{list-style-type:decimal !important;padding-left:1rem !important;background-image:none;}}}&.checkmark li{background-image:url(https://voyager.postman.com/icon/checkbox-outline-green-icon.svg);background-size:1.3rem 1.3rem;ol{li{list-style-type:decimal !important;&:before{content:"";}}}}'], u.colors.grey_90),
  Te = v.p.withConfig({
    displayName: "Paragraph__ParagraphStyles",
    componentId: "sc-1pl8sx4-0"
  })(["", ";box-sizing:inherit;display:block;line-height:1.57143;a{", "}ul{", "}ol{", "}"], function (r) {
    return r.textColor ? u.colors[r.textColor] : u.colors.grey_90;
  }, H.componentStyle.rules, ne.componentStyle.rules, ge.componentStyle.rules);
function we(_ref5) {
  var r = _ref5.textColor,
    i = _ref5.children,
    a = _ref5.dangerouslySetInnerHTML,
    o = _ref5.className;
  return /* @__PURE__ */t.jsx(Te, {
    className: o,
    textColor: r && r,
    dangerouslySetInnerHTML: a || null,
    children: i && i
  });
}
we.propTypes = {
  textColor: e.string,
  children: e.node,
  dangerouslySetInnerHTML: e.objectOf(e.string),
  className: e.string
};
we.defaultProps = {
  children: null,
  textColor: null,
  dangerouslySetInnerHTML: null,
  className: null
};
var Ve = v.button.withConfig({
    displayName: "BaseButtonStyles",
    componentId: "sc-18tp7ed-0"
  })(["align-items:center;appearance:none;border:1px solid transparent;border-radius:", ";cursor:pointer;display:inline-block;font-size:16px;font-weight:600;line-height:1.5;padding:8px 16px;margin:0 16px 0 0;user-select:none;transition:", ";text-align:center;&:hover,&:active{text-decoration:none;}&:focus{outline:none;}&:disabled,&.isDisabled{color:", ";cursor:not-allowed;background-image:none !important;background:", ";border-color:transparent;}"], u.borderRadius.small, u.transitions.all, u.colors.grey_20, u.colors.grey_2),
  Lr = v(Ve).withConfig({
    displayName: "BaseButtonStyles__Primary",
    componentId: "sc-18tp7ed-1"
  })(["color:", " !important;background-color:", ";transform:translateZ(0px);transition:none !important;&:hover,&:active{background-color:", ";border:1px solid transparent;-webkit-appearance:none;border-inline:1px solid ", ";}"], u.colors.white, u.colors.orange_65, u.colors.orange_55, u.colors.orange_55),
  Ft = v(Ve).withConfig({
    displayName: "BaseButtonStyles__Secondary",
    componentId: "sc-18tp7ed-2"
  })(["border:1px solid ", ";color:", " !important;&:hover,&:active{border:1px solid ", ";}"], u.colors.grey_40, u.colors.grey_60, u.colors.grey_60),
  Lt = v(Ve).withConfig({
    displayName: "BaseButtonStyles__Postcon",
    componentId: "sc-18tp7ed-3"
  })(['color:white !important;border:none;outline:none;position:relative;background:linear-gradient(90deg,#ff6c37 0%,#c64dda 100%);cursor:pointer;z-index:1;&:hover{transition:0.3s ease-in-out;background:white;box-shadow:0 0 1em -0.15em rgb(226,207,244);-webkit-box-shadow:0 0 1em -0.15em rgb(226,207,244);-moz-box-shadow:0 0 1em -0.15em rgb(226,207,244);}&:active{border:2px solid #ffff;}&::before{content:"";position:absolute;left:1px;right:1px;top:1px;bottom:1px;border-radius:4px;background:#15071f;z-index:-1;}&::after{content:"";font-size:16px;webkit-background-clip:text;color:white !important;}']);
function K(r) {
  var i = r.buttonType,
    a = r.dataTest,
    o = r.src,
    d = r.className,
    g = r.target,
    h = r.gaCategory,
    p = r.gaLabel,
    m = r.id,
    f = r.children,
    x = r.ariaLabel,
    b = r.event,
    _ = r.eventProp,
    w = r.as,
    L = function L() {
      h && p && J(h, p);
    };
  return i === "secondary" ? /* @__PURE__ */t.jsx(Ft, {
    as: w || null,
    "aria-label": x || null,
    href: o,
    "data-test": "".concat(a) ? "".concat(a) : "".concat(g),
    "data-event": b,
    "data-event-prop": _,
    className: d || null,
    id: ee(m),
    onClick: L,
    rel: z(g),
    target: V(g),
    children: f
  }) : i === "postcon" ? /* @__PURE__ */t.jsx(Lt, {
    as: w || null,
    "aria-label": x || null,
    href: o,
    "data-test": "".concat(a) ? "".concat(a) : "".concat(g),
    "data-event": b,
    "data-event-prop": _,
    className: d || null,
    id: ee(m),
    onClick: L,
    rel: z(g),
    target: V(g),
    children: f
  }) : /* @__PURE__ */t.jsx(Lr, {
    as: w || null,
    "aria-label": x || null,
    className: d || null,
    href: o || null,
    "data-test": "".concat(a) ? "".concat(a) : "".concat(g),
    "data-event": b,
    "data-event-prop": _,
    id: ee(m),
    onClick: L,
    rel: z(g),
    target: V(g),
    children: f
  });
}
K.propTypes = {
  event: e.string,
  eventProp: e.string,
  ariaLabel: e.string,
  buttonType: e.string,
  dataTest: e.string,
  src: e.string,
  target: e.string,
  className: e.string,
  id: e.string,
  gaLabel: e.string,
  gaCategory: e.string,
  children: e.node,
  as: e.string
};
K.defaultProps = {
  event: null,
  eventProp: null,
  ariaLabel: null,
  buttonType: "primary",
  dataTest: "",
  className: "",
  src: null,
  target: "",
  id: "",
  gaLabel: null,
  gaCategory: null,
  as: null,
  children: null
};
var Et = v.div.withConfig({
  displayName: "HeroStacked__ContentContainer",
  componentId: "sc-9uac7n-0"
})(["a{", "}"], H.componentStyle.rules);
function Er(_ref6) {
  var r = _ref6.backgroundColor,
    i = _ref6.title,
    a = _ref6.body,
    o = _ref6.bodyAlignment,
    d = _ref6.button,
    g = _ref6.media,
    h = _ref6.divider;
  return /* @__PURE__ */t.jsxs("div", {
    children: [/* @__PURE__ */t.jsx(U, {
      backgroundColor: r,
      children: /* @__PURE__ */t.jsx("div", {
        className: "container",
        children: /* @__PURE__ */t.jsxs("div", {
          className: "row",
          children: [/* @__PURE__ */t.jsxs("div", {
            className: "col-12 text-center",
            children: [g && g.src && /* @__PURE__ */t.jsx("img", {
              alt: g.alt,
              className: "mb-5 img-fluid ".concat(g.class ? " ".concat(g.class) : ""),
              height: "528",
              src: g.src,
              width: "1130"
            }), i && /* @__PURE__ */t.jsx("h1", {
              dangerouslySetInnerHTML: {
                __html: i.join("")
              }
            })]
          }), /* @__PURE__ */t.jsx(Et, {
            className: "'col-12 col-md-8 offset-md-2".concat(o ? " text-".concat(o) : "", "'"),
            children: a && /* @__PURE__ */t.jsx("div", {
              dangerouslySetInnerHTML: {
                __html: a.join("")
              }
            })
          }), d && Array.isArray(d) && /* @__PURE__ */t.jsx("div", {
            className: " col-12 text-center mb-sm-5",
            children: d.map(function (p) {
              return /* @__PURE__ */t.jsx("div", {
                className: "mb-4 d-sm-inline",
                children: /* @__PURE__ */t.jsx(K, {
                  buttonType: p.buttonType,
                  as: "a",
                  src: p.src,
                  target: p.target,
                  id: p.id,
                  gaCategory: p.gaCategory,
                  gaLabel: p.gaLabel,
                  className: p.type === "inline" ? "pl-0" : null,
                  icon: p.icon,
                  dataTest: p.id,
                  children: p.text
                })
              }, F.v4());
            })
          })]
        })
      })
    }), h !== !1 && /* @__PURE__ */t.jsx(q, {
      fullWidth: !0
    }) || null]
  });
}
Er.propTypes = {
  backgroundColor: e.string,
  title: e.arrayOf(e.string).isRequired,
  body: e.arrayOf(e.string).isRequired,
  bodyAlignment: e.string.isRequired,
  button: e.oneOfType([e.arrayOf(e.shape({
    type: e.string,
    text: e.string,
    src: e.string,
    target: e.string,
    id: e.string,
    gaCategory: e.string,
    gaLabel: e.string,
    icon: e.string
  })), e.oneOf([null])]),
  media: e.shape({
    src: e.string,
    alt: e.string,
    class: e.string
  }),
  divider: e.bool
};
Er.defaultProps = {
  backgroundColor: null,
  divider: null,
  media: {
    src: null,
    alt: null,
    class: null
  },
  button: [{
    id: null,
    gaCategory: null,
    gaLabel: null,
    icon: null
  }]
};
var Pt = v.div.withConfig({
    displayName: "SectionHeader__SectionHeaderStyles",
    componentId: "sc-1t7efdi-0"
  })(["padding-bottom:", ";color:", ";h2{font-family:", ";font-size:", ";line-height:", ";}"], function (r) {
    return r.paddingBottom || "60px ";
  }, function (r) {
    return r.textColor ? u.colors[r.textColor] : u.colors.black;
  }, function (r) {
    return r.font && "'".concat(r.font, "'") || null;
  }, function (r) {
    return r.font === "Degular-Display-Bold" && "56px";
  }, function (r) {
    return r.font === "Degular-Display-Bold" ? "0.9" : "1.5";
  }),
  Bt = v.div.withConfig({
    displayName: "SectionHeader__Body",
    componentId: "sc-1t7efdi-1"
  })(["a{", "}ul{", "}ol{", "}"], H.componentStyle.rules, ne.componentStyle.rules, ge.componentStyle.rules);
function ue(_ref7) {
  var r = _ref7.title,
    i = _ref7.font,
    a = _ref7.assignIDtoParent,
    o = _ref7.body,
    d = _ref7.link,
    g = _ref7.paddingBottom,
    h = _ref7.textAlign,
    p = _ref7.className,
    m = _ref7.textColor,
    f = _ref7.sectionHeaderClass;
  var x = r ? ee(r) : null,
    b = h === "center" ? " offset-md-2" : "",
    _ = h ? " text-".concat(h) : "";
  return /* @__PURE__ */t.jsxs(Pt, {
    className: "col-sm-12 col-md-8 ".concat(b, " ").concat(_, " ").concat(p),
    paddingBottom: g,
    textColor: m,
    font: i,
    children: [r && /* @__PURE__ */t.jsx("h2", {
      id: a ? "" : x,
      className: f,
      children: r
    }), o && o.length > 0 && /* @__PURE__ */t.jsx(Bt, {
      dangerouslySetInnerHTML: {
        __html: o.join("")
      }
    }, F.v4()), d && /* @__PURE__ */t.jsx(K, {
      buttonType: d.buttonType,
      as: "a",
      className: d.buttonType === "inline" ? "pl-0" : null,
      gaCategory: d.gaCategory,
      gaLabel: d.gaLabel,
      src: d.src,
      target: d.target,
      icon: d.icon,
      id: d.id,
      children: d.text
    })]
  });
}
ue.defaultProps = {
  title: "",
  font: null,
  body: null,
  assignIDtoParent: null,
  // dynamic - if true, assign ID to parent section container insead of child
  paddingBottom: "",
  link: null,
  className: "",
  textAlign: "",
  textColor: "",
  sectionHeaderClass: null
};
ue.propTypes = {
  title: e.string,
  font: e.string,
  className: e.string,
  textColor: e.string,
  body: e.arrayOf(e.string),
  assignIDtoParent: e.bool,
  paddingBottom: e.string,
  textAlign: e.string,
  sectionHeaderClass: e.string,
  link: e.oneOfType([e.arrayOf(e.shape({
    button: e.shape({
      buttonType: e.string,
      className: e.string,
      gaCategory: e.string,
      gaLabel: e.string,
      src: e.string,
      target: e.string,
      icon: e.string,
      id: e.string
    })
  })), e.oneOf([null]), e.shape({})])
};
function Pr(r) {
  var i = r.link,
    a = r.paddingTop,
    o = r.paddingBottom;
  return i ? /* @__PURE__ */t.jsx(U, {
    paddingTop: a || "30px",
    paddingBottom: o || "10px",
    children: /* @__PURE__ */t.jsx("div", {
      className: "container",
      children: /* @__PURE__ */t.jsx("div", {
        className: "row",
        children: /* @__PURE__ */t.jsx("div", {
          className: "col-12",
          children: i && /* @__PURE__ */t.jsx(Q, {
            src: i.src,
            linkType: "reversedArrowLink",
            children: i.text
          })
        })
      })
    })
  }) : null;
}
Pr.propTypes = {
  data: e.PropTypes.shape({
    paddingTop: e.string,
    paddingBottom: e.string,
    link: e.shape({
      text: e.string,
      src: e.string
    })
  })
};
Pr.defaultProps = {
  data: null
};
function Br(_ref8) {
  var r = _ref8.backgroundColor,
    i = _ref8.paddingBottomStyles,
    a = _ref8.paddingBottomHeader,
    o = _ref8.title,
    d = _ref8.body,
    g = _ref8.className,
    h = _ref8.link,
    p = _ref8.textAlign,
    m = _ref8.divider;
  return /* @__PURE__ */t.jsxs(t.Fragment, {
    children: [/* @__PURE__ */t.jsx(U, {
      backgroundColor: r,
      paddingBottom: i,
      children: /* @__PURE__ */t.jsx("div", {
        className: "container",
        children: /* @__PURE__ */t.jsx("div", {
          className: "row",
          children: /* @__PURE__ */t.jsx(ue, {
            title: o,
            body: d,
            className: g,
            link: h,
            textAlign: p,
            paddingBottom: a
          })
        })
      })
    }), m === !0 && /* @__PURE__ */t.jsx(q, {}) || null]
  });
}
Br.propTypes = {
  title: e.string,
  body: e.arrayOf(e.string),
  textAlign: e.string,
  link: e.shape({}),
  divider: e.bool,
  className: e.string,
  paddingBottomStyles: e.string,
  paddingBottomHeader: e.string,
  backgroundColor: e.string
};
Br.defaultProps = {
  title: "",
  body: "",
  link: null,
  className: "",
  divider: !0,
  textAlign: "",
  backgroundColor: "",
  paddingBottomStyles: "",
  paddingBottomHeader: "60px"
};
var jr = v.div.withConfig({
  displayName: "TextSection__ContentStyles",
  componentId: "sc-1n6kvy4-0"
})(["color:", ";ul{", ";}ol{", ";}a,a:hover,a:not([href]):not([class]){", ";}p,h2,h3,ol,ul{color:", ";}h2{font-family:", ";font-size:", ";line-height:", ";}h3{font-size:", ";line-height:", ";font-weight:", ";}"], function (r) {
  return r.textColor ? u.colors[r.textColor] : u.colors.black;
}, ne.componentStyle.rules, ge.componentStyle.rules, H.componentStyle.rules, function (r) {
  return r.textColor ? "".concat(u.colors[r.textColor], " !important") : u.colors.black;
}, function (r) {
  return r.headerFont && "'".concat(r.headerFont, "'") || null;
}, function (r) {
  return r.headerFont === "Degular-Display-Bold" && "56px";
}, function (r) {
  return r.headerFont === "Degular-Display-Bold" ? "0.9" : "1.5";
}, function (r) {
  return r.headerFont === "Degular-Display-Bold" && "32px";
}, function (r) {
  return r.headerFont === "Degular-Display-Bold" ? "32px" : "1.1428571429";
}, function (r) {
  return r.headerFont === "Degular-Display-Bold" ? "600" : "1.5";
});
function Ne(_ref9) {
  var r = _ref9.title,
    i = _ref9.headerFont,
    a = _ref9.subtitle,
    o = _ref9.body,
    d = _ref9.button,
    g = _ref9.link,
    h = _ref9.backgroundColor,
    p = _ref9.paddingBottom,
    m = _ref9.paddingTop,
    f = _ref9.className,
    x = _ref9.divider,
    b = _ref9.logo,
    _ = _ref9.layout,
    w = _ref9.SideXSideText,
    L = _ref9.textColor;
  var R;
  switch (_) {
    case "center":
      R = "offset-md-1";
      break;
    case "left":
      R = "offset-md-0";
      break;
    case "right":
      R = "offset-md-4";
      break;
    default:
      R = "offset-md-2";
  }
  return /* @__PURE__ */t.jsxs(t.Fragment, {
    children: [/* @__PURE__ */t.jsx(U, {
      backgroundColor: h,
      paddingBottom: p,
      paddingTop: m,
      children: w === !0 ? /* @__PURE__ */t.jsxs(t.Fragment, {
        children: [/* @__PURE__ */t.jsxs(jr, {
          textColor: L,
          headerFont: i,
          children: [b && /* @__PURE__ */t.jsx("img", {
            className: b.width ? "".concat(b.width) : "w-100 mb-4",
            src: b.src,
            alt: b.alt
          }), r && /* @__PURE__ */t.jsx("h2", {
            id: "".concat(ee(r)),
            children: r
          }), a && /* @__PURE__ */t.jsx(we, {
            className: "subtitle mb-4",
            children: a
          }), o && /* @__PURE__ */t.jsx("div", {
            dangerouslySetInnerHTML: {
              __html: o.join("")
            }
          })]
        }), d && Array.isArray(d) && d.map(function (l) {
          return /* @__PURE__ */t.jsx("div", {
            className: "mb-4 mr-3 d-lg-inline",
            children: /* @__PURE__ */t.jsx(K, {
              buttonType: l.buttonType,
              as: "a",
              src: l.src,
              target: l.target,
              id: l.id,
              gaCategory: l.gaCategory,
              gaLabel: l.gaLabel,
              className: l.type === "inline" ? "pl-0" : null,
              dataTest: l.id,
              onClick: function onClick() {
                J(l[0].category, l[0].label);
              },
              children: l.text
            })
          }, F.v4());
        }), g && Array.isArray(g) && g.map(function (l) {
          return /* @__PURE__ */t.jsx("p", {
            children: /* @__PURE__ */t.jsx(Q, {
              linkType: l.type,
              src: l.src,
              className: l.className && l.className,
              alternative: l.alternative ? l.alternative : !1,
              target: l.target ? l.target : "same-tab",
              gaCategory: l.gaCategory && l.gaCategory,
              gaLabel: l.gaLabel && l.gaLabel,
              id: l.id && l.id,
              ariaLabel: l.ariaLabel && l.ariaLabel,
              dataTest: l.id,
              children: l.text
            })
          }, F.v4());
        })]
      }) : /* @__PURE__ */t.jsx("div", {
        className: "container",
        children: /* @__PURE__ */t.jsx("div", {
          className: "row",
          children: /* @__PURE__ */t.jsxs("div", {
            className: "".concat(R, " ").concat(f),
            children: [/* @__PURE__ */t.jsxs(jr, {
              textColor: L,
              headerFont: i,
              children: [r && /* @__PURE__ */t.jsx("h2", {
                id: "".concat(ee(r)),
                children: r
              }), a && /* @__PURE__ */t.jsx(we, {
                className: "subtitle mb-4",
                children: a
              }), o && /* @__PURE__ */t.jsx("div", {
                dangerouslySetInnerHTML: {
                  __html: o.join("")
                }
              })]
            }), d && Array.isArray(d) && d.map(function (l) {
              return /* @__PURE__ */t.jsx("div", {
                className: "mb-4 mr-3 d-inline",
                children: /* @__PURE__ */t.jsx(K, {
                  buttonType: l.buttonType,
                  as: "a",
                  src: l.src,
                  target: l.target,
                  id: l.id,
                  gaCategory: l.gaCategory,
                  gaLabel: l.gaLabel,
                  className: l.type === "inline" ? "pl-0" : null,
                  dataTest: l.id,
                  onClick: function onClick() {
                    J(l[0].category, l[0].label);
                  },
                  children: l.text
                })
              }, F.v4());
            }), g && Array.isArray(g) && g.map(function (l) {
              return /* @__PURE__ */t.jsx("p", {
                children: /* @__PURE__ */t.jsx(Q, {
                  linkType: l.type,
                  src: l.src,
                  className: l.className && l.className,
                  alternative: l.alternative ? l.alternative : !1,
                  target: l.target ? l.target : "same-tab",
                  gaCategory: l.gaCategory && l.gaCategory,
                  gaLabel: l.gaLabel && l.gaLabel,
                  id: l.id && l.id,
                  ariaLabel: l.ariaLabel && l.ariaLabel,
                  dataTest: l.id,
                  children: l.text
                })
              }, F.v4());
            })]
          })
        })
      })
    }), x === !0 && /* @__PURE__ */t.jsx(q, {}) || null]
  });
}
Ne.propTypes = {
  layout: e.string,
  title: e.string,
  headerFont: e.string,
  subtitle: e.string,
  className: e.string,
  body: e.arrayOf(e.string),
  logo: e.shape({
    src: e.string,
    alt: e.string,
    width: e.string
  }),
  button: e.oneOfType([e.arrayOf(e.shape({
    cta: e.shape({
      buttonType: e.string,
      className: e.string,
      gaCategory: e.string,
      gaLabel: e.string,
      src: e.string,
      target: e.string,
      icon: e.string,
      id: e.string
    })
  })), e.oneOf([null]), e.shape({})]),
  link: e.oneOfType([e.arrayOf(e.shape({
    cta: e.shape({
      linkType: e.string,
      text: e.string,
      src: e.string,
      target: e.string,
      id: e.string,
      gaCategory: e.string,
      gaLabel: e.string,
      icon: e.string
    })
  })), e.oneOf([null]), e.shape({})]),
  backgroundColor: e.string,
  paddingBottom: e.string,
  paddingTop: e.string,
  divider: e.bool,
  SideXSideText: e.bool,
  textColor: e.string
};
Ne.defaultProps = {
  layout: "",
  title: "",
  headerFont: null,
  className: null,
  subtitle: "",
  body: null,
  button: {
    cta: {
      id: null,
      gaCategory: null,
      gaLabel: null,
      icon: null
    }
  },
  link: {
    cta: {
      id: null,
      gaCategory: null,
      gaLabel: null,
      icon: null
    }
  },
  logo: null,
  backgroundColor: "",
  paddingBottom: "",
  paddingTop: "",
  divider: !1,
  SideXSideText: !1,
  textColor: null
};
var Cr = v.div.withConfig({
  displayName: "VideoComponent__EmbedContainer",
  componentId: "sc-t4s1m3-0"
})(["display:block;padding:0px;overflow:hidden;width:100%;max-width:1440px;margin:auto;&.fullwrap{border-radius:", ";border:2px solid ", ";}&.top-bottom{border-top:4px solid ", ";border-bottom:4px solid ", ";-webkit-box-shadow:", ";box-shadow:", ";max-width:1600px;margin:auto;display:block;width:100%;@media screen and (min-width:1600px){border:4px solid ", ";border-radius:", ";}}"], u.borderRadius.small, function (r) {
  return r.borderColor ? u.colors[r.borderColor] : u.colors.grey_45;
}, u.colors.grey_30, u.colors.grey_30, u.shadows.screenshot_shadow, u.shadows.screenshot_shadow, u.colors.grey_30, u.borderRadius.large);
function Se(_ref10) {
  var r = _ref10.src,
    _ref10$recap = _ref10.recap,
    i = _ref10$recap === void 0 ? !0 : _ref10$recap,
    a = _ref10.id,
    o = _ref10.hostType,
    d = _ref10.paddingBottom,
    g = _ref10.paddingTop,
    h = _ref10.loop,
    p = _ref10.muted,
    m = _ref10.autoPlay,
    f = _ref10.controls,
    x = _ref10.poster,
    b = _ref10.title,
    _ = _ref10.aspectRatio,
    w = _ref10.caption,
    L = _ref10.border,
    R = _ref10.SideXSideVideo,
    l = _ref10.container,
    $ = _ref10.captionClassName,
    S = _ref10.borderColor;
  return /* @__PURE__ */t.jsxs(U, {
    paddingTop: g,
    paddingBottom: d,
    children: [R == null ? /* @__PURE__ */t.jsx("div", {
      className: l ? "container" : null,
      children: /* @__PURE__ */t.jsx("div", {
        className: l ? "row" : "row no-gutters",
        children: /* @__PURE__ */t.jsx("div", {
          className: "col-12",
          children: i && i ? /* @__PURE__ */t.jsx(Cr, {
            className: "embed-responsive ".concat(_, " ").concat(L),
            borderColor: S && S,
            children: o && o === "self" ? /* @__PURE__ */t.jsxs("video", {
              className: "embed-responsive-item",
              src: r,
              controls: f,
              id: a,
              type: "video/mp4",
              autoPlay: m,
              muted: p,
              loop: h,
              poster: x,
              allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
              children: [/* @__PURE__ */t.jsx("track", {
                kind: "captions",
                srcLang: "en"
              }), "Sorry, your browser doesn't support embedded videos."]
            }) : /* @__PURE__ */t.jsx("iframe", {
              title: b,
              loading: "lazy",
              className: "embed-responsive-item",
              src: r,
              allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
              allowFullScreen: !0,
              controls: f,
              autoPlay: m,
              muted: p,
              loop: h,
              poster: x
            })
          }) : null
        })
      })
    }) : /* @__PURE__ */t.jsx(Cr, {
      className: "embed-responsive ".concat(_, " ").concat(L),
      borderColor: S && S,
      children: o && o === "self" ? /* @__PURE__ */t.jsxs("video", {
        className: "embed-responsive-item",
        src: r,
        controls: f,
        id: a,
        type: "video/mp4",
        autoPlay: m,
        muted: p,
        loop: h,
        poster: x,
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        children: [/* @__PURE__ */t.jsx("track", {
          kind: "captions",
          srcLang: "en"
        }), "Sorry, your browser doesn't support embedded videos."]
      }) : /* @__PURE__ */t.jsx("iframe", {
        title: b,
        loading: "lazy",
        className: "embed-responsive-item",
        src: r,
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowFullScreen: !0,
        controls: f,
        autoPlay: m,
        muted: p,
        loop: h,
        poster: x
      })
    }), w !== "" && w !== void 0 && /* @__PURE__ */t.jsx("div", {
      className: "d-block mt-2 text-center small ".concat($),
      children: w
    }) || null]
  });
}
Se.propTypes = {
  src: e.string,
  id: e.string,
  autoPlay: e.bool,
  loop: e.bool,
  recap: e.bool,
  muted: e.bool,
  hostType: e.string,
  controls: e.bool,
  poster: e.string,
  paddingBottom: e.string,
  paddingTop: e.string,
  container: e.string,
  title: e.string,
  aspectRatio: e.string,
  caption: e.string,
  border: e.string,
  SideXSideVideo: e.bool,
  captionClassName: e.string,
  borderColor: e.string
};
Se.defaultProps = {
  id: "",
  src: "",
  loop: !1,
  muted: !1,
  autoPlay: !1,
  controls: !0,
  poster: null,
  hostType: "",
  paddingBottom: "20px",
  paddingTop: "0px",
  container: "",
  title: "this is a video",
  aspectRatio: "embed-responsive-16by9",
  recap: !0,
  caption: "",
  border: "",
  SideXSideVideo: !1,
  captionClassName: "col-10 offset-1",
  borderColor: "grey_45"
};
function ke(_ref11) {
  var r = _ref11.title,
    i = _ref11.iconList,
    a = _ref11.listClassName;
  return /* @__PURE__ */t.jsxs(t.Fragment, {
    children: [r && /* @__PURE__ */t.jsx("h3", {
      className: "mb-5",
      children: r
    }), /* @__PURE__ */t.jsx("div", {
      className: "row d-block ".concat(a, " mb-md-5"),
      children: i.map(function (o) {
        return /* @__PURE__ */t.jsxs("div", {
          className: "".concat(o.iconClassName || "col-12", " d-flex mb-5"),
          children: [/* @__PURE__ */t.jsx("img", {
            src: o.iconSrc,
            alt: "Icon",
            width: "50",
            height: "50",
            "aria-hidden": "true",
            className: "mr-5 img-fluid"
          }), o.text && /* @__PURE__ */t.jsx("div", {
            className: "align-self-center",
            children: /* @__PURE__ */t.jsx(Te, {
              className: "strong mb-0",
              children: o.text
            })
          })]
        }, F.v4());
      })
    })]
  });
}
ke.propTypes = {
  title: e.string,
  iconList: e.arrayOf(e.shape({})),
  listClassName: e.string
};
ke.defaultProps = {
  title: null,
  iconList: null,
  listClassName: "d-block"
};
var It = v.form.withConfig({
    displayName: "InputBox__SearchForm",
    componentId: "sc-emejc2-0"
  })(['input[name="FormButton"]{', " border:1px solid transparent;border-radius:0 4px 4px 0;font-weight:600;padding:8px 16px;transition:", ";}"], Lr.componentStyle.rules, u.transitions.all),
  Ot = v.div.withConfig({
    displayName: "InputBox__InputWrapper",
    componentId: "sc-emejc2-1"
  })(["display:flex;"]),
  $t = v.input.withConfig({
    displayName: "InputBox__InputField",
    componentId: "sc-emejc2-2"
  })(["background:", ";border:1px solid ", ";border-radius:4px 0 0 4px;box-sizing:border-box;box-shadow:none;color:", ";font-size:14px;height:40px;line-height:20px;margin:0;outline:0;padding:0 12px;transition:", ";width:100%;-webkit-appearance:none;:focus{border:1px solid ", ";color:#555;}::-ms-clear{display:none;width:0;height:0;}::-ms-reveal{display:none;width:0;height:0;}::-webkit-search-decoration,::-webkit-search-cancel-button,::-webkit-search-results-button,::-webkit-search-results-decoration{display:none;}"], u.colors.grey_00, u.colors.orange_65, u.colors.grey_40, u.transitions.all, u.colors.orange_65);
function pe(_ref12) {
  var r = _ref12.buttonText,
    i = _ref12.title,
    a = _ref12.inputQuery;
  var _gt = gt(""),
    _gt2 = _slicedToArray(_gt, 2),
    o = _gt2[0],
    d = _gt2[1];
  function g() {
    var f = document.createElement("a");
    f.target = "_blank", f.href = "".concat(o), f.click();
  }
  var h = function h(f) {
      d("".concat(a).concat(f));
    },
    p = function p() {
      var f = document.getElementById("input").value;
      d("".concat(a).concat(f)), g();
    },
    m = function m(f) {
      f.key === "Enter" && (f.preventDefault(), g());
    };
  return /* @__PURE__ */t.jsxs(t.Fragment, {
    children: [/* @__PURE__ */t.jsx("h2", {
      children: i
    }), /* @__PURE__ */t.jsx(It, {
      action: "#",
      method: "POST",
      target: "_blank",
      children: /* @__PURE__ */t.jsxs(Ot, {
        children: [/* @__PURE__ */t.jsx($t, {
          onChange: function onChange(f) {
            return h(f.target.value);
          },
          onKeyPress: m,
          type: "search",
          placeholder: "jsmith@example.com",
          autoComplete: "off",
          "aria-label": "jsmith@example.com",
          id: "input"
        }), /* @__PURE__ */t.jsx("input", {
          type: "button",
          name: "FormButton",
          value: r,
          onClick: p
        })]
      })
    })]
  });
}
pe.propTypes = {
  inputQuery: e.string,
  title: e.string,
  buttonText: e.string
};
pe.defaultProps = {
  inputQuery: "",
  title: "",
  buttonText: ""
};
var At = v.img.withConfig({
  displayName: "SideXSide__Image",
  componentId: "sc-npn8zl-0"
})(["&.fullwrap{border-radius:", ";border:2px solid ", ";}"], u.borderRadius.small, function (r) {
  return r.borderColor ? u.colors[r.borderColor] : u.colors.grey_45;
});
function Ir(r) {
  var i = r.media;
  return /* @__PURE__ */t.jsx(At, {
    src: i.media.src,
    alt: i.media.alt,
    height: i.media.height || "576",
    width: i.media.width || "700",
    fetchpriority: "auto",
    loading: "low",
    borderColor: i.media.borderColor && i.media.borderColor,
    className: "".concat(i.media.border ? i.media.border : "", "\n        ").concat(i.media.shadow === !0 ? "media-shadow-v6 img-fluid w-100" : "".concat(i.media.noFluid ? "" : " img-fluid w-100"))
  });
}
var Dt = function Dt(r) {
    return {
      media: /* @__PURE__ */t.jsx(Ir, {
        media: r
      }),
      video: /* @__PURE__ */t.jsx(Se, {
        aspectRatio: r.videoLeft.aspectRatio,
        autoPlay: r.videoLeft.autoPlay,
        border: r.videoLeft.border,
        caption: r.videoLeft.caption,
        controls: r.videoLeft.controls,
        hostType: r.videoLeft.hostType,
        id: r.videoLeft.id,
        loop: r.videoLeft.loop,
        muted: r.videoLeft.muted,
        paddingBottom: r.videoLeft.videoPaddingBottom,
        paddingTop: r.videoLeft.videoPaddingTop,
        poster: r.videoLeft.poster,
        recap: r.videoLeft.recap,
        SideXSideVideo: r.videoLeft.SideXSideVideo,
        src: r.videoLeft.src,
        title: r.videoLeft.title,
        type: r.videoLeft.type,
        borderColor: r.videoLeft.borderColor
      }),
      text: /* @__PURE__ */t.jsx(Ne, {
        backgroundColor: r.backgroundColor,
        body: r.textBodyLeft,
        button: r.buttonLeft,
        logo: r.logoLeft,
        link: r.linkLeft,
        paddingBottom: r.textPaddingBottomLeft,
        paddingTop: r.textPaddingTopLeft,
        SideXSideText: r.SideXSideTextLeft,
        subtitle: r.textSubtitleLeft,
        title: r.textTitleLeft,
        headerFont: r.headerFont,
        textColor: r.textColor
      }),
      list: /* @__PURE__ */t.jsx(ke, {
        title: r.listTitle,
        iconList: r.iconList,
        listClassName: r.listClassName
      }),
      input: /* @__PURE__ */t.jsx(pe, {
        title: r.inputTitle,
        inputQuery: r.inputQuery,
        buttonText: r.buttonText
      })
    };
  },
  Ht = function Ht(r) {
    return {
      media: /* @__PURE__ */t.jsx(Ir, {
        media: r
      }),
      video: /* @__PURE__ */t.jsx(Se, {
        aspectRatio: r.videoRight.aspectRatio,
        autoPlay: r.videoRight.autoPlay,
        border: r.videoRight.border,
        caption: r.videoRight.caption,
        controls: r.videoRight.controls,
        hostType: r.videoRight.hostType,
        id: r.videoRight.id,
        loop: r.videoRight.loop,
        muted: r.videoRight.muted,
        paddingBottom: r.videoRight.videoPaddingBottom,
        paddingTop: r.videoRight.videoPaddingTop,
        poster: r.videoRight.poster,
        recap: r.videoRight.recap,
        SideXSideVideo: r.videoRight.SideXSideVideo,
        src: r.videoRight.src,
        title: r.videoRight.title,
        type: r.videoRight.type,
        borderColor: r.videoRight.borderColor
      }),
      text: /* @__PURE__ */t.jsx(Ne, {
        backgroundColor: r.backgroundColor,
        body: r.textBodyRight,
        button: r.buttonRight,
        logo: r.logoRight,
        link: r.linkRight,
        paddingBottom: r.textPaddingBottomRight,
        paddingTop: r.textPaddingTopRight,
        SideXSideText: r.SideXSideTextRight,
        subtitle: r.textSubtitleRight,
        title: r.textTitleRight,
        headerFont: r.headerFont,
        textColor: r.textColor
      }),
      list: /* @__PURE__ */t.jsx(ke, {
        title: r.listTitle,
        iconList: r.iconList,
        listClassName: r.listClassName
      }),
      input: /* @__PURE__ */t.jsx(pe, {
        title: r.inputTitle,
        inputQuery: r.inputQuery,
        buttonText: r.buttonText
      })
    };
  };
function Or(r) {
  var i = r.layout,
    a = r.backgroundColor,
    o = r.paddingBottom,
    d = r.paddingTop,
    g = r.customColLeft,
    h = r.customColRight,
    p = r.headerTitle,
    m = r.headerFont,
    f = r.headerTextAlign,
    x = r.headerPaddingBottom,
    b = r.headerBody,
    _ = r.textTitleRight,
    w = r.textTitleLeft,
    L = r.textColor,
    R = r.left,
    l = r.right,
    $ = r.divider,
    S = r.fullWidth,
    W = r.headerBottomMargin,
    oe = r.headerLink,
    ie = r.sectionHeaderClass,
    le = r.id;
  var I, O;
  i === "small" && (I = "col-lg-4 offset-lg-0", O = "col-lg-7 offset-lg-1"), i === "medium" && (I = "col-lg-5 offset-lg-0", O = "col-lg-6 offset-lg-1"), i === "large" && (I = "col-lg-6 offset-lg-0", O = "col-lg-5 offset-lg-1"), i === "xlarge" && (I = "col-lg-7 offset-lg-0", O = "col-lg-4 offset-lg-1"), i === "xxlarge" && (I = "col-lg-7 offset-lg-0", O = "col-lg-3 offset-lg-1"), i === "xlarge-no-offset" && (I = "col-lg-7 offset-lg-0", O = "col-lg-5"), i === "equal" && (I = "col-lg-6", O = "col-lg-6"), i === "custom" && (I = g || "col-lg-7 offset-lg-0", O = h || "col-lg-4 offset-lg-1");
  var T, Y, X;
  R === "media" || l === "media" || l === "video" || R === "video" ? T = "align-items-center" : T = "", (l === "media" || l === "video" && i !== "equal") && (X = "order-lg-1 order-0 mb-5 mb-lg-0 ", Y = "order-lg-0 order-1 offset-md-1 col-md-8 offset-md-2"), l === "text" && R === "media" && (X = "col-md-8 offset-md-2", Y = "mb-5 mb-lg-0 "), l === "text" && R === "text" && (X = "col-md-6", Y = "col-md-6"), l === "media" && R === "input" && (X = "offset-md-0", Y = "mb-5 mb-lg-0 col-md-7"), (l === "list" && R === "text" || l === "video" && R === "video") && (X = "", Y = "mb-5 mb-lg-0 ");
  var G;
  _ ? G = _ : w ? G = w : G = null;
  var D = G ? ee(G) : null;
  return /* @__PURE__ */t.jsxs(t.Fragment, {
    children: [/* @__PURE__ */t.jsx(U, {
      id: D,
      backgroundColor: a,
      paddingBottom: o,
      paddingTop: d,
      textColor: L,
      children: /* @__PURE__ */t.jsxs("div", {
        className: "container",
        id: le,
        children: [p && /* @__PURE__ */t.jsx("div", {
          className: "row ".concat(W ? "".concat(W) : "mb-5"),
          children: /* @__PURE__ */t.jsx(ue, {
            title: p,
            body: b,
            textAlign: f,
            bottomMargin: "0",
            paddingBottom: x,
            link: oe,
            textColor: L,
            sectionHeaderClass: ie,
            font: m
          })
        }), /* @__PURE__ */t.jsxs("div", {
          className: "row ".concat(T),
          children: [/* @__PURE__ */t.jsx("div", {
            className: "".concat(I, " ").concat(Y || ""),
            children: Dt(r)[R]
          }), /* @__PURE__ */t.jsx("div", {
            className: "".concat(O, " ").concat(X || ""),
            children: Ht(r)[l]
          })]
        })]
      }, F.v4())
    }), $ === !0 && /* @__PURE__ */t.jsx(q, {
      fullWidth: S
    }) || null]
  });
}
Or.propTypes = {
  id: e.string,
  left: e.string,
  right: e.string,
  layout: e.string.isRequired,
  backgroundColor: e.string,
  paddingBottom: e.string,
  paddingTop: e.string,
  customColLeft: e.string,
  customColRight: e.string,
  headerTextAlign: e.string,
  headerTitle: e.string,
  headerFont: e.string,
  media: e.shape({
    src: e.string,
    alt: e.string,
    shadow: e.bool,
    border: e.string,
    height: e.string,
    width: e.string,
    notFluid: e.bool
  }),
  divider: e.bool,
  fullWidth: e.bool,
  headerBody: e.arrayOf(e.string),
  headerPaddingBottom: e.string,
  textTitleLeft: e.string,
  textTitleRight: e.string,
  textColor: e.string,
  headerBottomMargin: e.string,
  headerLink: e.shape({
    buttonType: e.string,
    text: e.string,
    src: e.string
  }),
  sectionHeaderClass: e.string
};
Or.defaultProps = {
  id: null,
  divider: !1,
  fullWidth: !1,
  headerTextAlign: "",
  customColLeft: "",
  customColRight: "",
  media: {
    src: null,
    alt: null,
    shadow: null,
    border: null,
    height: null,
    width: null,
    notFluid: !1
  },
  left: "",
  right: "",
  textTitleLeft: "",
  textTitleRight: "",
  headerTitle: "",
  headerFont: "",
  textColor: "",
  backgroundColor: null,
  paddingBottom: "",
  paddingTop: "",
  headerBody: null,
  headerPaddingBottom: "",
  headerBottomMargin: "mb-5",
  headerLink: {
    buttonType: null,
    text: null,
    src: null
  },
  sectionHeaderClass: null
};
var Wt = v.div.withConfig({
    displayName: "FeatureCard__FeatureWrapper",
    componentId: "sc-r96myo-0"
  })(["margin-bottom:5rem;ul{", "}"], ne.componentStyle.rules),
  Mt = v.div.withConfig({
    displayName: "FeatureCard__ContentContainer",
    componentId: "sc-r96myo-1"
  })(["a{", "}ul{", "}ol{", "}"], H.componentStyle.rules, ne.componentStyle.rules, ge.componentStyle.rules),
  zt = v.div.withConfig({
    displayName: "FeatureCard__ImageWrapper",
    componentId: "sc-r96myo-2"
  })(["margin-bottom:3rem;&.logo{height:80px;}&.thumbnail{height:19rem;}&.spot{height:12rem;}&.icon{height:5rem;}"]);
function qe(_ref13) {
  var r = _ref13.imageSize,
    i = _ref13.imageBorder,
    a = _ref13.title,
    o = _ref13.cardTitlePadding,
    d = _ref13.subtitle,
    g = _ref13.colWidth,
    h = _ref13.media,
    p = _ref13.link;
  var m = p || "";
  return m && (m.alternative = !1), /* @__PURE__ */t.jsxs(Wt, {
    className: "".concat(g, " pr-md-5 flex-column justify-content-between"),
    children: [/* @__PURE__ */t.jsxs("div", {
      children: [h && r !== null && /* @__PURE__ */t.jsx(zt, {
        className: "".concat(r, " ").concat(i && i),
        style: {
          backgroundImage: "url(\"".concat(h.src, "\")"),
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center left"
        }
      }), a && /* @__PURE__ */t.jsx("h3", {
        className: "h4 card-title ".concat(o || "mb-4"),
        children: a
      }), d && /* @__PURE__ */t.jsx(Mt, {
        dangerouslySetInnerHTML: {
          __html: d.join("")
        }
      })]
    }), p && /* @__PURE__ */t.jsx("div", {
      children: /* @__PURE__ */t.jsx(Q, {
        linkType: "arrowLink",
        src: m.src,
        target: m.target ? m.target : "new-tab-postman",
        children: m.text
      })
    })]
  });
}
qe.propTypes = {
  link: e.shape({}),
  media: e.shape({
    src: e.string
  }),
  title: e.string,
  cardTitlePadding: e.string,
  subtitle: e.arrayOf(e.string),
  colWidth: e.string,
  imageSize: e.string,
  imageBorder: e.string
};
qe.defaultProps = {
  link: null,
  media: null,
  title: null,
  cardTitlePadding: null,
  subtitle: null,
  colWidth: "col-lg-6 col-xl-4",
  imageSize: "icon",
  imageBorder: null
};
var Vt = v.div.withConfig({
  displayName: "Feature__BodyCopy",
  componentId: "sc-1m2zhqr-0"
})(["p{", "}a{", "}"], Te.componentStyle.rules, H.componentStyle.rules);
function $r(_ref14) {
  var r = _ref14.paddingTop,
    i = _ref14.paddingBottom,
    a = _ref14.paddingBottomHeader,
    o = _ref14.divider,
    d = _ref14.backgroundColor,
    g = _ref14.title,
    h = _ref14.className,
    p = _ref14.body,
    m = _ref14.headerLink,
    f = _ref14.textAlign,
    x = _ref14.media,
    b = _ref14.items,
    _ = _ref14.id,
    w = _ref14.footerCopy,
    L = _ref14.bodyLink;
  var R = g || p && p.length > 0 || m;
  return /* @__PURE__ */t.jsxs("div", {
    children: [/* @__PURE__ */t.jsx(U, {
      paddingTop: r,
      paddingBottom: i || "30px",
      backgroundColor: d,
      children: /* @__PURE__ */t.jsxs("div", {
        className: "container",
        id: _ || "",
        children: [/* @__PURE__ */t.jsxs("div", {
          className: "row",
          children: [R && /* @__PURE__ */t.jsx(ue, {
            title: g,
            body: p,
            className: h,
            paddingBottom: a,
            link: m,
            textAlign: f
          }), /* @__PURE__ */t.jsx("div", {
            className: "col-sm-6 offset-sm-3 col-lg-3 offset-lg-1 text-center",
            children: x && /* @__PURE__ */t.jsx("img", {
              className: "img-fluid mb-5",
              src: x.src,
              alt: x.alt
            })
          })]
        }), /* @__PURE__ */t.jsx("div", {
          className: "row",
          children: b.map(function (l) {
            return /* @__PURE__ */t.jsx(qe, {
              imageSize: l.imageSize,
              imageBorder: l.imageBorder,
              title: l.title,
              cardTitlePadding: l.cardTitlePadding,
              subtitle: l.subtitle,
              colWidth: l.colWidth,
              media: l.media,
              link: l.link
            }, F.v4());
          })
        }), /* @__PURE__ */t.jsx("div", {
          className: "row",
          children: /* @__PURE__ */t.jsx("div", {
            className: "col-sm-12 col-lg-8",
            children: w && /* @__PURE__ */t.jsx(Vt, {
              dangerouslySetInnerHTML: {
                __html: w.join("")
              }
            })
          })
        }), L && Array.isArray(L) && L.map(function (l) {
          return /* @__PURE__ */t.jsx("p", {
            children: /* @__PURE__ */t.jsx(Q, {
              linkType: l.type,
              src: l.src,
              className: l.className && l.className,
              alternative: l.alternative ? l.alternative : !1,
              target: l.target ? l.target : "same-tab",
              gaCategory: l.gaCategory && l.gaCategory,
              gaLabel: l.gaLabel && l.gaLabel,
              id: l.id && l.id,
              ariaLabel: l.ariaLabel && l.ariaLabel,
              children: l.text
            })
          }, F.v4());
        })]
      })
    }), o === !0 && /* @__PURE__ */t.jsx(q, {}) || null]
  });
}
$r.propTypes = {
  paddingTop: e.string,
  paddingBottom: e.string,
  paddingBottomHeader: e.string,
  divider: e.bool,
  backgroundColor: e.string,
  title: e.string,
  body: e.arrayOf(e.string),
  headerLink: e.shape({}),
  textAlign: e.string,
  media: e.shape({
    src: e.string,
    alt: e.string
  }),
  items: e.arrayOf(e.shape({})),
  id: e.string,
  footerCopy: e.arrayOf(e.string),
  bodyLink: e.arrayOf(e.shape({})),
  className: e.string
};
$r.defaultProps = {
  paddingTop: null,
  paddingBottom: null,
  paddingBottomHeader: null,
  divider: null,
  backgroundColor: null,
  title: null,
  body: null,
  headerLink: null,
  textAlign: null,
  media: null,
  items: null,
  id: null,
  footerCopy: null,
  bodyLink: null,
  className: null
};
var Qt = v.div.withConfig({
    displayName: "SideBarStyles__SideWrap",
    componentId: "sc-zn9lpa-0"
  })(["display:inline-flex;flex-direction:column;top:0;margin-bottom:32px;"]),
  Kt = v.a.withConfig({
    displayName: "SideBarStyles__SideLink",
    componentId: "sc-zn9lpa-1"
  })(["appearance:none;-webkit-appearance:none;-moz-appearance:none;background:none;box-shadow:none;color:", ";display:inline-block;font-size:1.4rem;font-weight:400;margin-inline-start:0px;padding:6px 12px;transition:", ";&:hover,&:active,&.current-page{background-color:", ";color:", ";text-decoration:none;}@media (min-width:991px){margin-inline-start:-12px;}"], u.colors.grey_90, u.transitions.all, u.colors.grey_10, u.colors.grey_90);
function Ar(_ref15) {
  var r = _ref15.src,
    i = _ref15.alt;
  return /* @__PURE__ */t.jsx("img", {
    src: r,
    alt: i
  });
}
Ar.propTypes = {
  src: e.string,
  alt: e.string
};
Ar.defaultProps = {
  src: null,
  alt: null
};
var He = v.div.withConfig({
    displayName: "Hero__ContentWrapper",
    componentId: "sc-96ntor-0"
  })(["p{", "}a{", "}ul{", "}ol{", "}"], Te.componentStyle.rules, H.componentStyle.rules, ne.componentStyle.rules, ge.componentStyle.rules),
  qt = v.p.withConfig({
    displayName: "Hero__ParentTitleText",
    componentId: "sc-96ntor-1"
  })(["color:", ";text-transform:uppercase;font-weight:600;"], u.colors.orange_40),
  Ut = v.p.withConfig({
    displayName: "Hero__ParentTitleTemp",
    componentId: "sc-96ntor-2"
  })(["color:", ";font-weight:600;"], u.colors.grey_90),
  Yt = v.p.withConfig({
    displayName: "Hero__ParentSubtitleText",
    componentId: "sc-96ntor-3"
  })(["color:", ";text-transform:uppercase;font-weight:600;"], u.colors.orange_40);
function Dr(_ref16) {
  var r = _ref16.heroLayout,
    i = _ref16.sideXSideLayout,
    a = _ref16.divider,
    o = _ref16.backgroundColor,
    d = _ref16.backgroundImage,
    g = _ref16.title,
    h = _ref16.subtitle,
    p = _ref16.body,
    m = _ref16.contentAlignment,
    f = _ref16.button,
    x = _ref16.media,
    b = _ref16.backlink,
    _ = _ref16.parentTitle,
    w = _ref16.parentTitleTemp,
    L = _ref16.parentSubtitle,
    R = _ref16.inputTitle,
    l = _ref16.inputQuery,
    $ = _ref16.buttonText;
  var S, W;
  i === "small" && (S = "col-lg-4 offset-lg-0", W = "col-lg-7 offset-lg-1"), i === "medium" && (S = "col-lg-5 offset-lg-0", W = "col-lg-6 offset-lg-1"), i === "xlarge" && (S = "col-lg-7 offset-lg-0", W = "col-lg-4 offset-lg-1");
  var oe = b || _ ? "" : "mt-4",
    ie = /* @__PURE__ */t.jsx("div", {
      className: "col-12 ".concat(S, " d-flex align-items-center"),
      children: /* @__PURE__ */t.jsxs("div", {
        className: "".concat(oe, " text-center text-lg-left"),
        children: [b && /* @__PURE__ */t.jsx("div", {
          className: "row",
          children: /* @__PURE__ */t.jsx("div", {
            className: "col-12 mb-4",
            children: /* @__PURE__ */t.jsx(Q, {
              src: b.src,
              className: b.className,
              linkType: "reversedArrowLink",
              children: b.text
            })
          })
        }), _ && /* @__PURE__ */t.jsx("div", {
          className: "row",
          children: /* @__PURE__ */t.jsx("div", {
            className: "col-12",
            children: /* @__PURE__ */t.jsx(qt, {
              children: _
            })
          })
        }), w && /* @__PURE__ */t.jsx("div", {
          className: "row",
          children: /* @__PURE__ */t.jsx("div", {
            className: "col-12",
            children: /* @__PURE__ */t.jsx(Ut, {
              children: w
            })
          })
        }), /* @__PURE__ */t.jsx("h1", {
          dangerouslySetInnerHTML: {
            __html: g.join("")
          }
        }), L && /* @__PURE__ */t.jsx("div", {
          className: "row",
          children: /* @__PURE__ */t.jsx("div", {
            className: "col-12",
            children: /* @__PURE__ */t.jsx(Yt, {
              children: L
            })
          })
        }), h && /* @__PURE__ */t.jsx(He, {
          dangerouslySetInnerHTML: {
            __html: h.join("")
          }
        }), l && /* @__PURE__ */t.jsx(pe, {
          title: R,
          inputQuery: l,
          buttonText: $
        }), /* @__PURE__ */t.jsx("div", {
          className: "row justify-content-center justify-content-lg-start",
          children: f && Array.isArray(f) && f.map(function (T) {
            return /* @__PURE__ */t.jsx("div", {
              className: "mb-4 ml-2",
              children: /* @__PURE__ */t.jsx(K, {
                buttonType: T.buttonType,
                as: "a",
                src: T.src,
                target: T.target,
                id: T.id,
                gaCategory: T.gaCategory,
                gaLabel: T.gaLabel,
                className: "".concat(T.className, " ").concat(T.type === "inline" && "pl-0"),
                icon: T.icon,
                dataTest: T.id,
                children: T.text
              })
            }, F.v4());
          })
        })]
      })
    }),
    le = /* @__PURE__ */t.jsx("div", {
      className: "col-12 ".concat(W, " d-flex align-items-center justify-content-center"),
      children: /* @__PURE__ */t.jsx("img", {
        alt: x.alt,
        className: x.shadow === !0 ? "media-shadow-v6 img-fluid" : "img-fluid mt-5 mt-lg-0",
        height: "576",
        src: x.src,
        width: "576",
        fetchpriority: "high",
        loading: "eager"
      })
    }),
    I = /* @__PURE__ */t.jsx("div", {
      className: "col-12 text-center",
      children: x && x.src && /* @__PURE__ */t.jsx("img", {
        alt: x.alt,
        className: "mb-5 img-fluid ".concat(x.class ? " ".concat(x.class) : ""),
        height: "528",
        src: x.src,
        width: "1130",
        fetchpriority: "high",
        loading: "eager"
      })
    }),
    O = /* @__PURE__ */t.jsxs(t.Fragment, {
      children: [/* @__PURE__ */t.jsx("div", {
        className: "col-12 text-center",
        children: /* @__PURE__ */t.jsx("h1", {
          dangerouslySetInnerHTML: {
            __html: g.join("")
          }
        })
      }), /* @__PURE__ */t.jsx(He, {
        className: "col-12 col-md-8 offset-md-2 ".concat(m ? "text-".concat(m) : ""),
        children: p && /* @__PURE__ */t.jsx("div", {
          dangerouslySetInnerHTML: {
            __html: p.join("")
          }
        })
      }), f && Array.isArray(f) && /* @__PURE__ */t.jsx("div", {
        className: " col-12 text-center mb-sm-5",
        children: f.map(function (T) {
          return /* @__PURE__ */t.jsx("div", {
            className: "mb-4 d-sm-inline",
            children: /* @__PURE__ */t.jsx(K, {
              buttonType: T.buttonType,
              as: "a",
              src: T.src,
              target: T.target,
              id: T.id,
              gaCategory: T.gaCategory,
              gaLabel: T.gaLabel,
              className: "".concat(T.className, " ").concat(T.type === "inline" && "pl-0"),
              icon: T.icon,
              dataTest: T.id,
              children: T.text
            })
          }, F.v4());
        })
      })]
    });
  return /* @__PURE__ */t.jsxs(t.Fragment, {
    children: [/* @__PURE__ */t.jsx(U, {
      backgroundColor: o,
      style: {
        backgroundImage: d,
        backgroundSize: "cover"
      },
      children: /* @__PURE__ */t.jsx("div", {
        className: "container",
        children: /* @__PURE__ */t.jsxs("div", {
          className: "row",
          children: [r === "sideXSide" && /* @__PURE__ */t.jsxs(t.Fragment, {
            children: [ie, le]
          }), r === "topXBottom" && /* @__PURE__ */t.jsxs(t.Fragment, {
            children: [I, O]
          }), r === "centered" && /* @__PURE__ */t.jsxs("div", {
            className: "col-12 ".concat(m ? "text-".concat(m) : "text-center"),
            children: [/* @__PURE__ */t.jsx("h1", {
              className: "mb-4",
              dangerouslySetInnerHTML: {
                __html: g.join("")
              }
            }), h && /* @__PURE__ */t.jsx(He, {
              dangerouslySetInnerHTML: {
                __html: h.join("")
              }
            })]
          })]
        })
      })
    }), a !== !1 && /* @__PURE__ */t.jsx(q, {
      fullWidth: !0
    }) || null]
  });
}
Dr.propTypes = {
  heroLayout: e.string.isRequired,
  sideXSideLayout: e.string,
  divider: e.bool,
  backgroundColor: e.string,
  backgroundImage: e.string,
  inputTitle: e.string,
  inputQuery: e.string,
  buttonText: e.string,
  title: e.arrayOf(e.string).isRequired,
  subtitle: e.arrayOf(e.string),
  body: e.arrayOf(e.string),
  contentAlignment: e.string,
  parentTitle: e.string,
  parentTitleTemp: e.string,
  parentSubtitle: e.string,
  backlink: e.shape({
    text: e.string,
    className: e.string,
    src: e.string
  }),
  button: e.oneOfType([e.arrayOf(e.shape({
    type: e.string,
    text: e.string,
    src: e.string,
    target: e.string,
    id: e.string,
    gaCategory: e.string,
    gaLabel: e.string,
    icon: e.string
  })), e.oneOf([null])]),
  media: e.shape({
    src: e.string,
    alt: e.string,
    shadow: e.bool,
    class: e.string
  })
};
Dr.defaultProps = {
  sideXSideLayout: null,
  divider: !1,
  backgroundColor: null,
  backgroundImage: null,
  inputTitle: null,
  inputQuery: null,
  buttonText: null,
  subtitle: null,
  body: null,
  contentAlignment: null,
  parentTitle: null,
  parentTitleTemp: null,
  parentSubtitle: null,
  backlink: null,
  button: null,
  media: null
};
export { wt as ArrowLinkStyles, Pr as BackLinkSection, K as BaseButton, Q as BaseLink, H as BaseLinkStyles, Br as CallOut, q as Divider, $r as Feature, qe as FeatureCard, Rr as Footer, ve as FooterLinkStyles, vr as HR, Dr as Hero, Er as HeroStacked, ke as IconList, Ar as Image, pe as InputBox, ge as OrderedListStyles, we as Paragraph, Te as ParagraphStyles, Lr as Primary, Ft as Secondary, ue as SectionHeader, U as SectionStyles, Kt as SideLink, Qt as SideWrap, Or as SideXSide, Fr as Table, Ne as TextSection, ne as UnorderedListStyles, Se as VideoComponent };